// API prefix - configurable via runtime environment
// Priority: window._env_.API_PREFIX > REACT_APP_API_PREFIX > default '/api'
// For production, set API_PREFIX environment variable in docker-compose
export const API_PREFIX = 
  (typeof window !== 'undefined' && window._env_?.API_PREFIX) || 
  process.env.REACT_APP_API_PREFIX || 
  '/api';

// Backend URL - configurable via runtime environment
// Priority: window._env_.BACKEND_URL > REACT_APP_BACKEND_URL > empty string
export const BACKEND_URL = 
  (typeof window !== 'undefined' && window._env_?.BACKEND_URL) || 
  process.env.REACT_APP_BACKEND_URL || 
  '';
